import { useCallback, useState } from 'react';

export function useRenameFolderDialog() {
  const [renameFolderId, setRenameFolderId] = useState<number>(null);

  const onCloseRenameFolder = useCallback(() => {
    setRenameFolderId(null);
  }, [setRenameFolderId]);

  const onOpenRenameFolder = useCallback(
    (folderId: number) => {
      setRenameFolderId(folderId);
    },
    [setRenameFolderId]
  );
  return { renameFolderId, onCloseRenameFolder, onOpenRenameFolder };
}
